import {
  type GCSBucket,
  Provider,
  type Account,
  type S3Bucket,
} from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { useDAL } from '@/contexts/useDAL';

const normalizeBuckets = (buckets: GCSBucket[] | S3Bucket[] | undefined) =>
  buckets?.map((bucket) => ({
    bucketName: bucket.bucketName,
    regionName: 'location' in bucket ? bucket.location : bucket.regionName,
  })) as S3Bucket[];

export const useBuckets = (account?: Account, region?: string): S3Bucket[] => {
  const dal = useDAL();
  const bucketsResponse = {
    [Provider.Aws]: dal.restore.s3Buckets.list(account).body?.buckets,
    [Provider.Gcp]: dal.restore.gcsBuckets.list(account).body?.buckets,
    [Provider.Azure]: null,
    [Provider.MongoAtlas]: null,
    [Provider.ProviderUnspecified]: null,
  }[account?.cloudProvider ?? Provider.ProviderUnspecified];

  return useMemo(() => {
    if (!account?.id || !bucketsResponse) {
      return [];
    }

    const originBuckets = normalizeBuckets(bucketsResponse) ?? [];
    if (!region) {
      return originBuckets;
    }

    return originBuckets.filter((bucket) => bucket.regionName === region);
  }, [bucketsResponse, region, account]);
};
